import React, { useEffect, useState } from 'react';
import { Command } from 'cmdk';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Image, FileCode, Hammer, Grid3X3, History, GitCompare,
  RefreshCw, Clock, Bell, BarChart3, HelpCircle, Search,
} from 'lucide-react';

const pages = [
  { name: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
  { name: 'Images', path: '/images', icon: Image },
  { name: 'Blueprints', path: '/blueprints', icon: FileCode },
  { name: 'Trigger Build', path: '/build', icon: Hammer },
  { name: 'Build Matrix', path: '/build-matrix', icon: Grid3X3 },
  { name: 'Build History', path: '/history', icon: History },
  { name: 'Compare Images', path: '/compare', icon: GitCompare },
  { name: 'Lifecycle', path: '/lifecycle', icon: RefreshCw },
  { name: 'Schedules', path: '/schedules', icon: Clock },
  { name: 'Notifications', path: '/notifications', icon: Bell },
  { name: 'Usage', path: '/usage', icon: BarChart3 },
  { name: 'Support', path: '/support', icon: HelpCircle },
];

export function CommandPalette() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center pt-[20vh]"
      onClick={() => setOpen(false)}
      style={{ background: 'rgba(0,0,0,0.5)' }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-lg rounded-lg border bg-popover shadow-2xl overflow-hidden"
        style={{ background: '#fff' }}
      >
        <Command label="Command Palette">
          <div className="flex items-center border-b px-3" style={{ height: 48 }}>
            <Search className="mr-2 h-4 w-4 shrink-0 opacity-50" />
            <Command.Input
              placeholder="Type a page name..."
              className="flex h-11 w-full bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground"
              style={{ border: 'none', fontSize: 14 }}
            />
          </div>
          <Command.List className="max-h-[300px] overflow-y-auto p-1" style={{ padding: 8 }}>
            <Command.Empty className="py-6 text-center text-sm text-muted-foreground">
              No results found.
            </Command.Empty>
            <Command.Group heading="Pages" style={{ padding: '4px 0' }}>
              {pages.map((page) => {
                const Icon = page.icon;
                return (
                  <Command.Item
                    key={page.path}
                    value={page.name}
                    onSelect={() => {
                      navigate(page.path);
                      setOpen(false);
                    }}
                    className="flex items-center gap-2 rounded-sm px-2 py-2 text-sm cursor-pointer"
                    style={{ padding: '8px 12px', borderRadius: 6 }}
                  >
                    <Icon className="h-4 w-4 opacity-60" />
                    <span>{page.name}</span>
                  </Command.Item>
                );
              })}
            </Command.Group>
          </Command.List>
        </Command>
      </div>
    </div>
  );
}
